import { displayUrl, openableUrl } from '@sonder/shared'
import { ArrowUpRight } from './icons'

/**
 * The arrow beside a link field that opens it in a new tab. Renders nothing until the value is a usable
 * link; hovering names the exact address it opens.
 */
export function OpenLink({ value }: { value: string }) {
  const href = openableUrl(value)
  if (!href) return null
  const shown = displayUrl(href)
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" title={`Open ${shown}`} aria-label={`Open ${shown} in a new tab`} className="inline-flex h-9 w-9 shrink-0 items-center justify-center text-dim hover:text-ink">
      <ArrowUpRight size={14} />
    </a>
  )
}
